import { Header } from "@growth/dweb-header";
import { getCookieByName } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { useBreakpointV2 } from "@tm/ui-widgets";
import dynamic from "next/dynamic";
import Router from "next/router";
import { useEffect, useState } from "react";
import { LandingHeaderMobile } from "..";

const GiDwebAuth = dynamic(() =>
  import("@growth/gi-dweb-auth").then((p) => p.default)
);
const GiMwebAuth = dynamic(
  () => import("@growth/gi-mweb-auth").then((p) => p.MwebAuth),
  {
    ssr: false,
  }
);
export interface GIHeaderProps {
  lobName?:
    | "Flights"
    | "Hotels"
    | "Holidays"
    | "Buses"
    | "Cabs"
    | "Trains"
    | "Giftcards"
    | "insurance";
  sticky?: boolean;
  shouldShowCloseButton?: boolean;
  navOrigin?: string;
}

interface GIAuthProps {
  headerProps?: GIHeaderProps;
  mobileTitle?: string;
  forceLogin?: boolean;
  myOrders?: boolean;
  goToMyOrders?: () => void;
  displayWhiteHeader?: boolean;
  showPwaHeaderBackButton?: boolean;
  onLoginSuccess?: () => void;
  showPwaHeader?: boolean;
}

let isCalled = false;
export function GIInsuranceHeader({
  headerProps = {},
  mobileTitle = "",
  forceLogin = false,
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  showPwaHeaderBackButton = true,
  onLoginSuccess,
  showPwaHeader = true,
}: GIAuthProps) {
  const device = useBreakpointV2();
  const headerPropsWithDefaults: GIHeaderProps = {
    lobName: "insurance",
    sticky: true,
    shouldShowCloseButton: true,
    navOrigin: "https://www.goibibo.com",
    ...headerProps,
  };
  let authComponent = null;
  const [isAuthComponentVisible, setIsAuthComponentVisible] =
    useState(forceLogin);

  useEffect(() => {
    setIsAuthComponentVisible(forceLogin);
  }, [forceLogin]);

  if (isAuthComponentVisible) {
    authComponent =
      device === "lg" ? (
        <GiDwebAuth
          prefillMobileNumber={undefined}
          showCloseButton={false}
          onClose={() => console.log("Closed")}
          lobName={"insurance"}
          onLoginSuccess={() => {
            if (onLoginSuccess) {
              if (!isCalled) {
                isCalled = true;
                onLoginSuccess();
              }
            } else if (getCookieByName("next_page_req")) {
              window.location.href = `https://tripmoney.goibibo.com/insurance/next-page`;
            } else {
              Router.reload();
            }
          }}
          configData={undefined}
        />
      ) : (
        <GiMwebAuth
          prefillMobileNumber={undefined}
          showCloseButton={false}
          onClose={() => console.log("Closed")}
          lobName={""}
          onLoginSuccess={() => {
            if (onLoginSuccess) {
              if (!isCalled) {
                isCalled = true;
                onLoginSuccess();
              }
            } else if (getCookieByName("next_page_req")) {
              window.location.href = `https://tripmoney.goibibo.com/insurance/next-page`;
            } else {
              setIsAuthComponentVisible(false);
              setTimeout(() => {
                Router.reload();
              }, 100);
            }
          }}
          showAuth={true}
        />
      );
    authComponent = (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          backgroundColor: "rgba(0,0,0,0.7)",
        }}
      >
        {authComponent}
      </div>
    );
  }
  return (
    <>
      {authComponent}
      {device === "lg" ? (
        <Header {...headerPropsWithDefaults} />
      ) : showPwaHeader ? (
        <LandingHeaderMobile
          headerTitle={mobileTitle}
          myOrders={myOrders}
          goToMyOrders={goToMyOrders}
          displayWhiteHeader={displayWhiteHeader}
          partnerType={PARTNER.GI}
          insuranceHeader
          showPwaHeaderBackButton={showPwaHeaderBackButton}
        />
      ) : null}
    </>
  );
}
